import { useState } from 'react';
import { Avatar } from '@mui/material';
import { authService } from '../services/authService';

const PHOTO_CDN_URL = import.meta.env.VITE_PHOTO_CDN_URL || 'https://photos.agendario.com.br';

/**
 * Avatar que busca foto do profissional no bucket CloudFlare R2
 * Sempre tenta carregar a foto. Se não existir (404), exibe as iniciais
 * @param {string} [ownerUserId] - userId do dono do profissional. Quando não informado,
 *   usa o userId do usuário logado (profissional próprio).
 */
export default function ProfessionalAvatar({ professionalId, photoTimestamp, name, ownerUserId, sx, children }) {
  const [imageError, setImageError] = useState(false);

  // Para profissionais compartilhados, a foto está no bucket do owner (não do usuário logado)
  const userInfo = authService.getUserInfo();
  const userId = ownerUserId || userInfo?.userId;

  // URL da foto no bucket CloudFlare R2
  // Formato: userId/professionalId.jpg (namespace por conta para segurança)
  // Cache busting: adiciona ?v=timestamp apenas se photoTimestamp existir (após upload)
  const photoUrl = userId && professionalId 
    ? `${PHOTO_CDN_URL}/${userId}/${professionalId}.jpg${photoTimestamp ? `?v=${photoTimestamp}` : ''}` 
    : null;

  const handleImageError = () => {
    console.log('Erro ao carregar imagem:', photoUrl);
    setImageError(true);
  };

  // Avatar só carrega src se NÃO houver children
  // Sempre tenta carregar se photoUrl existir, só mostra children após erro
  const shouldShowImage = photoUrl && !imageError;
  
  console.log('ProfessionalAvatar render:', { professionalId, photoUrl, imageError, shouldShowImage });

  return (
    <Avatar
      src={shouldShowImage ? photoUrl : undefined}
      imgProps={{
        onError: handleImageError
      }}
      sx={sx}
    >
      {shouldShowImage ? null : children}
    </Avatar>
  );
}
